import { useMutation } from '@apollo/client/react';
import { notify } from '@components/ui/molecules/Toast';
import { CreateOrganizationDocument } from '@graphql/types/documents';
import { removeEmptyValues } from '@shared/utils/removeEmpty';
import { useCallback } from 'react';

import type { CreateOrganizationInput, OrgResponse } from '../types';

export const useCreateOrg = () => {
  const [createOrgMutation, { loading: isLoading }] = useMutation(CreateOrganizationDocument);

  const doCreateOrg = useCallback(
    async (data: CreateOrganizationInput): Promise<OrgResponse> => {
      const inputData = removeEmptyValues(data) as CreateOrganizationInput;
      const response = await createOrgMutation({
        variables: { input: inputData },
      });
      const organizationRes = response.data?.createOrganization;

      if (!organizationRes) {
        throw new Error('Organiztion creation failed');
      }

      notify.success({ title: 'Organization created successfully' });

      return organizationRes as OrgResponse;
    },
    [createOrgMutation]
  );

  return { doCreateOrg, isLoading };
};
